<template>
  <div class="batch-flow">
    <div class="container">
      <div class="batch-flow-header">
        <label for="">批次填充</label>
        <a href="#" @click.prevent="closeBtnClicked" class="h4 close-btn">
          <b-icon icon="x"></b-icon>
        </a>
      </div>
  
      <div class="batch-body py-4">

        <div v-if="step === 1">
          <p class="text-center">請掃描酒桶條碼</p>

          <b-input-group>
            <b-form-input ref="keg-input" v-model="inputKegID" placeholder="酒桶編號" v-on:keyup.enter="inputKegKeyEnter"></b-form-input>
            <b-input-group-append>
              <b-button variant="secondary" size="sm" :disabled="kegIdInvalid" @click="inputKegID = ''">清除</b-button>
              <b-button variant="primary" size="sm" :disabled="kegIdInvalid" @click="kegReadBtnClicked">加入</b-button>
            </b-input-group-append>
          </b-input-group>

          <div class="mt-3">
            <IOSBarcode/>
          </div>
          
          <div class="mt-3">

            <div class="keg-list" :class="{'keg-error': !item.updated && item.error, 'keg-updated': item.updated}" v-for="(item, index) in kegs" :key="index">
              <div @click="kegNameClicked(index)">
                <b-icon icon="x-circle-fill" class="text-danger" v-if="!item.updated && item.error"></b-icon>
                <b-icon icon="check-circle-fill" class="text-success" v-if="item.updated"></b-icon>
                {{ item.keg.kid }}
              </div>
              
              <a href="#" @click.prevent="removeKeg(index)">
                <b-icon icon="x"></b-icon>
              </a>
            </div>
          </div>

          <div class="batch-footer">
            <div class="row align-items-center">
              <div class="col-4">
                {{ kegs.length }} 筆資料
              </div>

              <div class="col">
                <b-button variant="primary" class="w-100" :disabled="kegs.length === 0" @click="batchFlowCheckBtnClicked">
                  下一步
                </b-button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="step === 2">
          <p class="text-center">執行結果</p>

          <div class="mt-3">

            <div class="keg-list" :class="{'keg-error': !item.updated && item.error, 'keg-updated': item.updated}" v-for="(item, index) in kegs" :key="index">
              <div @click="kegNameClicked(index)">
                <b-icon icon="x-circle-fill" class="text-danger" v-if="!item.updated && item.error"></b-icon>
                <b-icon icon="check-circle-fill" class="text-success" v-if="item.updated"></b-icon>
                {{ item.keg.kid }}
              </div>

            </div>
          </div>

          <div class="batch-footer">
            <b-button variant="primary" class="w-100" @click="finishBtnClicked">
              完成
            </b-button>
          </div>
        </div>

      </div>

    </div>
    <KegAlertModal v-model="showAlertModal" :kegs="kegs" @continue="batchFlowExecuteBtnClicked"></KegAlertModal>
  </div>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
import IOSBarcode from "../../../components/IOSBarcode.vue";
import KegAlertModal from "../modals/KegAlertModal.vue";
import { mapActions } from 'vuex';

export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'BatchFill',
  data() {
    return {
      step: 1,

      inputKegID: '',
      kegs: [],
      showAlertModal: false,

      inputBusy: false,
    };
  },
  components: {
    IOSBarcode,
    KegAlertModal,
  },
  computed: {
    kegIdInvalid() {
      return this.inputKegID.trim().length === 0;
    },
    hasInvalidKeg() {
      for (let i=0;i<this.kegs.length;i++) {
        if (this.kegs[i].error) {
          return true;
        }
      }
      return false;
    },
  },
  async mounted() {
    this.handleAsyncTask(async() => {
      await this.refreshAlertKegList();
    });
    setTimeout(() => {
      this.$refs['keg-input'].focus();
    }, 100);
  },
  beforeDestroy() {
  },
  methods: {
    ...mapActions('alertKeg', ['refreshAlertKegList', 'checkKidNeedAlert']),
    closeBtnClicked() {
      this.$bvModal.msgBoxConfirm('確認取消執行中的流程嗎?', {
        title: '確認',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: '離開',
        cancelTitle: '繼續流程',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          this.$router.push({name: 'kegBatchIndex'});
        }
      })
      .catch(err => {
        // An error occurred
        alert(err);
      });
    },

    async readKeg(kegId) {
      const kid = kegId.trim();
      const existKeg = this.kegs.find(keg => keg.keg.kid === kid);

      if (existKeg) {
        // this.$bvModal.msgBoxOk(`酒桶已存在! (酒桶編號: ${kid})`, {
        //   title: '發生錯誤',
        //   size: 'sm',
        //   centered: true
        // }).then();
        
        this.inputKegID = '';
        this.$refs['keg-input'].focus();
        return;
      }
      try {
        const keg = await this.$store.dispatch('api/getKegInfoPromise', {kid});
        
        if (keg === null) {
          this.$bvModal.msgBoxOk(`找不到酒桶! (酒桶編號: ${kid})`, {
            title: '發生錯誤',
            size: 'sm',
            centered: true
          }).then();
          return;
        }
        
        const kegObj = {
          keg,
          error: false,
          updated: false,
          errorMsg: '',
        }
        
  
        const needAlert = await this.checkKidNeedAlert(keg.kid);
        if (needAlert) {
          kegObj.error = true;
          kegObj.errorMsg = '需要被通報的警示酒桶';
        } else if (keg.status !== 0) {
          kegObj.error = true;
          kegObj.errorMsg = '非在庫狀態的酒桶';
        } else if (!keg.washed) {
          kegObj.error = true;
          kegObj.errorMsg = '未清洗的酒桶';
        } else if (keg.filled) {
          kegObj.error = true;
          kegObj.errorMsg = '已填充的酒桶';
        }
  
        this.kegs.push(kegObj);
        this.inputKegID = '';
        this.$refs['keg-input'].focus();
      } catch (error) {
        this.$bvModal.msgBoxOk(`${error.toString()}`, {
          title: '發生錯誤',
          size: 'sm',
          centered: true
        }).then();
        return;
      }
    },
    async inputKegKeyEnter() {
      if (this.inputBusy) {
        return;
      }
      this.inputBusy = true;
      try {
        if (!this.kegIdInvalid) {
          const kegId = this.inputKegID;
          this.inputKegID = '';
          await this.handleAsyncTask(async () => { await this.readKeg(kegId)});
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.inputBusy = false;
      }
    },
    async kegReadBtnClicked() {
      if (this.inputBusy) {
        return;
      }
      this.inputBusy = true;
      try {
        if (!this.kegIdInvalid) {
          const kegId = this.inputKegID;
          this.inputKegID = '';
          await this.handleAsyncTask(async () => { await this.readKeg(kegId)});
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.inputBusy = false;
      }
    },
    removeKeg(index) {
      this.kegs.splice(index, 1);
    },
    kegNameClicked(index) {
      if (!this.kegs[index].updated && this.kegs[index].error) {
        this.$bvModal.msgBoxOk(`${this.kegs[index].errorMsg}`, {
          title: '警告',
          size: 'sm',
          centered: true
        }).then();
      }
    },
    async batchFlowExecute() {
      let count = 0;
      for (let i=0;i<this.kegs.length;i++) {
        const kegObj = this.kegs[i];
        try {
          await this.$store.dispatch('api/postKegFilledPromise', {
            kegSerial: kegObj.keg.serial,
          });
          this.kegs[i].updated = true;
          count += 1;
        } catch (error) {
          this.kegs[i].error = true;
          this.kegs[i].errorMsg = error.toString();
        }
      }
      this.$bvModal.msgBoxOk(`共填充 ${count} 個酒桶`, {
        title: '流程已完成',
        size: 'sm',
        centered: true
      }).then();
      this.step = 2;
    },
    async batchFlowCheckBtnClicked() {
      if (this.hasInvalidKeg) {
        this.showAlertModal = true;
      } else {
        this.batchFlowExecuteBtnClicked();
      }
    },
    async batchFlowExecuteBtnClicked() {
      this.showAlertModal = false;
      this.$bvModal.msgBoxConfirm('確認執行流程嗎?', {
        title: '確認',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: '執行',
        cancelTitle: '取消',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(async (value) => {
        if (value) {
          await this.handleAsyncTask(async () => { await this.batchFlowExecute()});
        }
      })
      .catch(err => {
        // An error occurred
        alert(err);
      });
    },
    finishBtnClicked() {
      this.$router.push({name: 'kegBatchIndex'});
    }
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
@import "src/assets/scss/batch";
</style>